import { z } from "zod";
import { ChargesSchema } from "./charge.type";

const planActions = ["subscribe"] as const;
export const PlanActionsEnum = z.enum(planActions);
export type PlanActionsEnum = z.infer<typeof PlanActionsEnum>;

export const PlanSchema = z.object({
  code: z.string(),
  name: z.string(),
  invoice_display_name: z.string().nullable(),
  description: z.string().nullable(),
  interval: z.string(),
  amount_cents: z.number(),
  amount_currency: z.string(),
  trial_period: z.number().optional(),
  pay_in_advance: z.boolean(),
  charges: ChargesSchema.readonly(),
  productLink: z.string().optional(),
  productEulaLink: z.string().optional()
});

export const PlanWithSubscriptionSchema = z.object({
  plan: PlanSchema,
  subscribed: z.boolean()
});

export const PlansWithSubscriptionSchema = z.array(PlanWithSubscriptionSchema);

export const PlansSchema = z.array(PlanSchema);

export type Plan = z.infer<typeof PlanSchema>;
export type Plans = z.infer<typeof PlansSchema>;

export type PlanWithsubscription = z.infer<typeof PlanWithSubscriptionSchema>;
export type PlansWithSubscription = z.infer<typeof PlansWithSubscriptionSchema>;
